import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="6.8mm"
    height={12.481}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 98531 47850"
    {...props}
  >
    <defs>
      {/* <style>{".fil1{fill:#2b2a29}"}</style> */}
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M63504 44930c613 3360 4389 2889 7625 2889h20638c2262 0 6645 599 6753-3629 76-3036-298-7029-462-10149L96724 4499C96582-307 93611 13 90831 1L70189 7c-3894-10-4891 1328-4992 5218-168 6603-625 13332-925 20012-146 3250-292 6481-433 9746-94 2176-659 8176-335 9947zm27805-12383c587-5825-3479-10833-9103-11495-6067-711-10964 3827-11548 9108-667 6041 3764 10982 9127 11549 6005 633 10983-3794 11524-9162zM79521 5600c-3458 700-6355 4233-5468 8455 1855 8827 15716 6400 13858-2991-665-3373-4172-6317-8390-5464zM40380 43981c-307-713-230-1759-261-2711l18847 7c-33 929 52 1988-255 2694-855 284-17447 290-18331 10zm-171-5847c-339-2422-71-7059-71-9717 0-8050-692-7524 2285-7526 3317-1 15293-229 16397 186 237 3143 236 13872 77 17072l-18688-15zm-3189 5483c245 4856 6600 3637 9907 3637 2467 0 11605 409 13123-435 698-384 1369-1083 1700-1880 594-1441 320-7970 320-9765-4-17940 2010-17453-9891-17411-2498 7-11595-423-13170 494-1701 993-1995 2401-1999 4908-7 5936-254 15255 10 20452zm16757-14269-5 1262 5-1262zM99 44930c615 3360 4390 2889 7626 2889h20639c2260 0 6643 599 6752-3629 77-3036-298-7029-462-10149L33319 4499C33179-307 30207 13 27425 1L6783 7C2891-3 1894 1335 1794 5225c-170 6603-626 13332-926 20012-145 3250-293 6481-433 9746-93 2176-658 8176-336 9947zm27805-12383c587-5825-3479-10833-9103-11495-6066-711-10963 3827-11546 9108-668 6041 3764 10982 9126 11549 6004 633 10982-3794 11523-9162zM16118 5600c-3458 700-6358 4233-5471 8455 1856 8827 15719 6400 13861-2991-668-3373-4172-6317-8390-5464z"
        style={{
          fill: "#2b2a29",
        }}
        className="fill"
      />
      <circle cx={17579} cy={31412} r={5434} className="fil1" />
      <circle cx={17579} cy={12576} r={2898} className="fil1" />
      <circle cx={81334} cy={12576} r={2898} className="fil1" />
      <circle cx={81334} cy={31412} r={5434} className="fil1" />
      <path
        d="M45326 26450h8446v4160h-8446z"
        style={{
          fill: "none",
          // stroke: "#2b2a29",
          strokeWidth: 1104.12,
        }}
        className="stroke1"
      />
    </g>
  </svg>
)
export default SvgComponent
